const MAX_MOBILE_SCREEN_WIDTH = "1023px"

export default { MAX_MOBILE_SCREEN_WIDTH }
